/**
 * snapshotsactions.js
 * Created by zl52fc on 11/17/2020.
 */

import * as types from '../actiontypes';
import env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export const getSnapshotsForDocument = (engagementId, documentId) => {
	const url = env.getBaseURL(serviceURL, engagementId) + `Forms/` + documentId + `/Snapshots`;

	return {
		type: types.GET_SNAPSHOTS,
		meta: {
			api: {
				url,
				method: 'GET'
			}
		}
	};
};
